import { QuestionnaireDetailsService } from './../../../../service/questionnaire/questionnaire.service';
import { GelAllOpportunityRequestModel } from './../../../../opportunities-v2/models/opportunity-list.model';
import { LeadServiceN } from './../../../../leads-v2/services/lead.service';
import { GetAllLeadRequestModel } from './../../../../leads-v2/model/lead-request.model';
import { AccountServiceN } from './../../../../accounts-v2/services/account.services';
import { GelAllAccountRequestModel } from './../../../../accounts-v2/models/account-request.model';
import { CasesService } from './../../../../cases-v2/services/cases.service';
import { OpportunitiesService } from './../../../../opportunities-v2/services/opportunity.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AccountGroupId } from 'src/app/accounts/account.enum';
import { AccountService } from 'src/app/accounts/accountService';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { CrmAccountFieldService } from 'src/app/configurations/crm/account/fields/fields.service';
import { ContactService } from 'src/app/contacts/contactService';
import { LeadService } from 'src/app/leads-v2/leadService';
import { SavedSearchParentModule } from 'src/app/misc/saved-searches/models/saved-search.static';
import { SavedSearchesService } from 'src/app/misc/saved-searches/services/saved-searches.service';
import { UserService } from 'src/app/service/userservice';
import { FormControlList } from '../../constants/formcontrol-list.constants';
import { Fields } from '../../models/column-settings.model';
import { LocalDatePipe } from '../../pipes/local-date.pipe';
import { AccountsHttpService } from '../../services/accounts.http.service';
import { AppRuleSelectionService } from '../rule-selection/app.rule.selection.service';
import { TimeZoneService } from '../../services/timezone.service';
import { StatusGroupIds, TypeGroupIds } from '../../constants/category-groupid.constants';
import { GelAllContactRequestModel, FilterObject, FilterInColumn, SavedFilterData } from 'src/app/modules/shared/models/filter.model';
import { MessageService } from 'primeng/api';
import { LogService } from '../shared-logs/log-service.service';
import { ImportserialService } from '../../services/importserial.service';
import { ObjectNames } from '../../constants/object.names';
import { AccountModuleId, CaseModuleId, ContactModuleId, GeneralLedgerModuleId, JournalModuleId, LeadModuleId, OpportunityModuleId, ReconciliationReportModuleId, ReportModuleId, TaskModuleId, TrialBalanceModuleId } from '../../constants/modules.constant';
import { DynamicTableService } from '../../services/dynamic-table/dynamic-table.service';
import { SharedTaskService } from 'src/app/shared/shared-task/shared-task.service';
import { ProductsService } from 'src/app/inventory/products/products.service';
import { TaskStatus } from '../../model/models';
import { SharedContactV1Service } from '../shared-contacts-v1/shared-contact-v1-Service';
import { ReconciliationReportSearchService } from 'src/app/finance/reconcilation/service/reconciliation-report-search.service';
import { filterDateRangeHelper } from '../../helpers/filter-date-range.helper';
import { PaymentmethodService } from 'src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service';
import { SalesOrderService } from 'src/app/inventory/sales-order/sales-order.service';
import { STATUS_TYPES } from 'src/app/inventory/sales-order/models/sales-receipt.model';
import { SOObjectNames } from 'src/app/inventory/sales-order/constants/constants';
@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit, OnChanges {

  @Input() listCols: Fields[];
  @Input() fromProductVisibilityModule: boolean = false;
  listColsVM: Fields[] = [];
  @Input() showAllFileds: boolean = false;
  @Input() secondaryClass: boolean = true;
  @Input() isWorkspaceModule?: boolean = false;
  @Input() isTaskModule?: boolean = false;
  @Input() selectedParentModule: { name: string, objectId: number, channelId: number };
  @Input() accountChannelId: number = 0;
  @Input() saveFilterData: SavedFilterData;
  @Input() selectedFilterValue: string;  // selectedFilterValue using Only For Task Module to set the selected tab value
  @Output() applyFiltersColumns: EventEmitter<{ selectedFilter: FilterInColumn[], selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[] }> = new EventEmitter<{ selectedFilter: FilterInColumn[], selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[] }>();

  //Search Value
  @Output() autoSearchFilters: EventEmitter<{ filterItem: FilterObject, filterInColumn: FilterInColumn[] }> = new EventEmitter<{ filterItem: FilterObject, filterInColumn: FilterInColumn[] }>();
  @Input() autoSearchFilterList: [] = [];
  @Input() autocompleteFieldsList: string[] = [];
  currentSearchFilterItem: FilterObject = {} as FilterObject;

  @ViewChild('filterOptions') filterOptions;

  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  filters: FilterObject[] = [];
  appliedSlectedColumns: FilterObject[] = [];
  choices = [
    { id: 1, name: "AND" },
    { id: 2, name: "OR" },
  ];

  dataIsOperatorList: string[] = [
    "Yesterday", "Today", "Tomorrow",
    "Last 7 Days", "Last 15 Days", "Last 30 Days", "Last 60 Days", "Last 90 Days",
    "Last Week", "Last Week-to-date", "This Week", "This Week-to-date", "Next Week", "Next Week-to-date",
    "Last Month", "Last Month-to-date", "This Month", "This Month-to-date", "Next Month", "Next Month-to-date",
    "Last Fiscal Quarter", "Last Fiscal Quarter-to-date", "This Fiscal Quarter", "This Fiscal Quarter-to-date", "Next Fiscal Quarter", "Next Fiscal Quarter-to-date",
    "Last Fiscal Year", "Last Fiscal Year-to-date", "This Fiscal Year", "This Fiscal Year-to-Last Month", "This Fiscal Year-to-date", "Next Fiscal Year", "Next Fiscal Year-to-date",
  ];
  ratingList: number[] = [1, 2, 3, 4, 5];

  //date range dropdown change
  todayDate: Date;
  dateRangeFrom: Date;
  dateRangeTo: Date;
  noContactFindOrLoadingText: string;
  empltyFields: FilterObject[] = [];
  selectedColumns: FilterInColumn[] = [];
  isSelectedChannelWise: boolean = false;
  selectedCountries: any[] = [];
  selectedStates: any[] = [];

  autocompleteFields: string[] = ['businessName', 'visit_businessname', 'mainCustomer', 'accountName','accountname','method','status','number', 'name', 'associationName', 'seniority', 'report', 'assistant', 'id', 'reconciliationReportType', 'num', 'reconciliationReportAmount', 'reconciliationReportBalance'];
  autoCompleteFieldsForBetweenNotBetween: string[] = ['reconciliationReportAmount', 'reconciliationReportBalance'];
  singleSelectFields: string[] = ['caseAssociationName'];
  salesReceiptModuleId: number = 0 ;

  constructor(
    private ruleService: AppRuleSelectionService,
    private accountService: AccountService,
    private accountsHttpService: AccountsHttpService,
    private fieldService: CrmAccountFieldService,
    private contactService: ContactService,
    private savedSearchesService: SavedSearchesService,
    private configService: ConfigurationService,
    private leadService: LeadService,
    public userService: UserService,
    private appMainService: AppMainService,
    public app: AppMainComponent,
    public localDatePipe: LocalDatePipe,
    private timeZoneService: TimeZoneService,
    private messageService: MessageService,
    private logService: LogService,
    private importService: ImportserialService,
    private opportunitiesService: OpportunitiesService,
    private accountServiceN: AccountServiceN,
    private leadServiceN: LeadServiceN,
    private casesService: CasesService,
    private dynamicTableService: DynamicTableService,
    private taskService: SharedTaskService,
    private productsService: ProductsService,
    private sharedContactV1Service: SharedContactV1Service,
    private questionnaireDetailsService: QuestionnaireDetailsService,
    private paymentMethodService: PaymentmethodService,
    private salesOrderService: SalesOrderService,
    private reconciliationReportSearchService: ReconciliationReportSearchService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listCols && changes.listCols.currentValue) {
      this.listCols = changes.listCols.currentValue;
      this.listCols = this.listCols.filter((data) => {
        return !(data.formControlType == "FileUpload" || data.formControlType == "Picture" || data.columnName == 'activeInactiveStatus') && data?.mapObject != 'opportunityProduct';
      });
      this.listColsVM = JSON.parse(JSON.stringify(this.listCols));
      if (this.listCols?.length > 0) {
        this.retainSavedFilelds(this.saveFilterData);
      }
    }

    if (changes.selectedParentModule && changes.selectedParentModule.currentValue) {
      this.selectedParentModule = changes.selectedParentModule.currentValue;
      this.clearFilterOnChannelChange();
    }
    if (changes.autoSearchFilterList && changes.autoSearchFilterList.currentValue) {
      let filterItem = this.filters?.find(data => data.id == this.currentSearchFilterItem?.id && data.columnName == this.currentSearchFilterItem?.columnName);
      if (filterItem && changes?.autoSearchFilterList.currentValue) {
        filterItem.valueList = changes?.autoSearchFilterList?.currentValue ?? [];
      }
    }

    if (changes?.saveFilterData && changes?.saveFilterData?.currentValue) {
      this.saveFilterData = changes?.saveFilterData?.currentValue;
      if (this.listCols?.length > 0 && this.saveFilterData) {
        this.retainSavedFilelds(this.saveFilterData);
      }
    }

    if (changes.selectedFilterValue && changes.selectedFilterValue.currentValue) {
      this.selectedFilterValue = changes.selectedFilterValue.currentValue;
    }

    if (changes?.saveFilterData && changes?.saveFilterData?.currentValue == null && !this.fromProductVisibilityModule) {
      this.clearFilterOnChannelChange();
    }
  }

  ngOnInit(): void {
    this.todayDate = this.app._showDateTimeWithZone(new Date());
    this.salesReceiptModuleId = JSON.parse(localStorage.getItem('userPermissions'))?.find((p) => p.objectName == SOObjectNames.RECEIVE_PAYMENT)?.objectId;
  }

  ngAfterViewInit(): void {
    if (this.autocompleteFieldsList?.length > 0) {
      this.autocompleteFields = [...this.autocompleteFields, ...this.autocompleteFieldsList];
    }
  }

  retainSavedFilelds(saveFilterData: SavedFilterData) {
    let filterData: FilterInColumn[] = [];
    filterData = saveFilterData?.filter;
    this.appliedSlectedColumns = [];
    if (filterData?.length > 0) {
      filterData?.forEach((data: FilterInColumn, index: number) => {
        let selectedFileld: Fields = this.listCols.find(col => col?.id == data?.fieldId);
        let item: FilterObject = {
          fieldIdNo: data?.fieldId,
          selectedField: selectedFileld,
          columnName: selectedFileld?.columnName,
          choice: this.choices.find(choice => choice?.name == data?.operationType),
          operators: selectedFileld?.operators,
          selectedOperator: data?.operator,
          fields: this.listCols,
          id: index,
          fieldDataType: selectedFileld?.fieldDataType,
          formControlType: selectedFileld?.formControlType,
          isCustom: selectedFileld?.isCustom,
          hasValue: false,
          noValue: false,
          isRequired: { isFieldRequired: false, isOperatorRequired: false, isValueRequired: false, isCountryRequired: false, isStateRequired: false },
        }
        this.gettingValuesForFilter(item, selectedFileld, data);
        this.appliedSlectedColumns.push(item);
        this.isSelectedChannelWise = true;
      });
      this.filters = JSON.parse(JSON.stringify(this.appliedSlectedColumns));
      this.addressValidation();
    }
  }

  gettingValuesForFilter(item: FilterObject, selectedFileld: Fields, data: FilterInColumn) {
    item.valueList = [];
    let selectedValue = { name: '' };
    let selectedValueList: { name: string }[] = [];
    // has value , no value
    if (data?.operator == "HasValue") {
      item.hasValue = true;
      item.noValue = false;
      item.selectedValue = 'any';
      item.selectedValue2 = '';
    } else if (data?.operator == "NoValue") {
      item.hasValue = false;
      item.noValue = true;
      item.selectedValue = '';
      item.selectedValue2 = '';
    } else {
      // -------------------------- other all operator handle--------
      if (item?.isCustom && !this.isWorkspaceModule) {
        if (
          item.fieldDataType == 'Enum' ||
          [FormControlList.MultipleDropDownList,
          FormControlList.DropDownList,
          FormControlList.UserLookup,
          FormControlList.CheckBox,
          FormControlList.RadioButton,
          FormControlList.Rating
          ].includes(item?.formControlType)
        ) {
          if (item?.formControlType == FormControlList.Rating) {
            if (data?.values?.length == 1) {
              item.selectedValue = Number(data?.values[0]);
            } else if (data?.values?.length > 1) {
              item.selectedValue = Number(data?.values[0]);
              item.decimalBetweenNotBetweenValue = Number(data?.values[1])
            }
          } else if (item?.formControlType == FormControlList.UserLookup) {
            this.getUserList(item, data);
          } else {
            item.valueList = item?.selectedField?.pickListValues;
            this.forCustomValues(item, data);
          }
        } else if (item.fieldDataType == 'Boolean' || item?.formControlType == FormControlList.ToggleButton) {
          item.valueList = ['true', 'false'];
          item.selectedValue = data.values[0];
        } else {
          this.bindingFilterValues(item, selectedFileld, data);
        }
      } else {
        this.bindingFilterValues(item, selectedFileld, data);
      }
      // ----------------------------
    }
  }

  bindingFilterValues(item: FilterObject, selectedFileld: Fields, data: FilterInColumn) {
    let selectedValue = { name: '' };
    if (this.autocompleteFields.includes(selectedFileld?.columnName)) {
      item.valueList.push({ name: data?.values[0] });
      item.selectedValue = selectedValue;
      item.selectedValue.name = data?.values[0];
    } else if (([FormControlList.MultipleDropDownList,
    FormControlList.DropDownList,
    FormControlList.CheckBox,
    FormControlList.RadioButton
    ].includes(selectedFileld?.formControlType)) && selectedFileld.isCustom && this.isWorkspaceModule) {
      item.selectedValue = data?.values;
      item.valueList = data?.values?.map(value => ({ id: value, value: value })) || [];
    } else if (item?.formControlType == FormControlList.UserLookup) {
      this.getUserList(item, data);
    } else if (selectedFileld?.fieldDataType == 'String') {
      if (selectedFileld?.formControlType == 'InputBox') {
        item.selectedValue = data?.values[0];
      } else if (selectedFileld?.formControlType == 'DropDownList') {
        item.valueList.push({ name: data?.values[0] });
        item.selectedValue = selectedValue;
        item.selectedValue.name = data?.values[0];
      } else if (([FormControlList.InputBox,
      FormControlList.Email,
      FormControlList.Phone,
      FormControlList.URL,
      FormControlList.RichText,
      FormControlList.Barcode,
      FormControlList.IPAddress,
      FormControlList.EncryptedText,
      FormControlList.MultiLine,
      FormControlList.AutoNumber,
      ].includes(selectedFileld?.formControlType)) && selectedFileld.isCustom && this.isWorkspaceModule) {
        item.selectedValue = data?.values[0];
      }
    } else if ((item.fieldDataType == 'Boolean' || item?.formControlType == FormControlList.ToggleButton) && selectedFileld.isCustom && this.isWorkspaceModule) {
      item.valueList = ['true', 'false'];
      item.selectedValue = data.values[0];
    }
    else if (selectedFileld?.fieldDataType == 'Enum') {
      if (selectedFileld?.formControlType == 'Rating') {
        if (data?.values?.length == 1) {
          item.selectedValue = Number(data?.values[0]);
        } else if (data?.values?.length > 1) {
          item.selectedValue = Number(data?.values[0]);
          item.decimalBetweenNotBetweenValue = Number(data?.values[1])
        }
      } else {
        this.selectColumnField(selectedFileld?.columnName?.toLowerCase(), item, data);
      }
    } else if (selectedFileld?.fieldDataType == 'Number' || selectedFileld?.fieldDataType == 'Decimal') {
      // item.selectedValue = Number(data?.values[0]);
      if (data?.values?.length == 1) {
        item.selectedValue = Number(data?.values[0]);
      } else if (data?.values?.length > 1) {
        item.selectedValue = Number(data?.values[0]);
        item.decimalBetweenNotBetweenValue = Number(data?.values[1])
      }
    } else if (selectedFileld?.fieldDataType == 'Time') {
      item.valueList = this.dataIsOperatorList;
      item.selectedValue = data?.values[0];
      item.selectedValue2 = data?.values?.[1] || null;
    } else if (selectedFileld?.fieldDataType == 'DateTime') {
      this.retrieveDataForDateFields(item, selectedFileld, data);
    }
  }

  retrieveDataForDateFields(item: FilterObject, selectedFileld: Fields, data: FilterInColumn) {
    if (item?.selectedOperator == "On" || item?.selectedOperator == "NotOn") {
      item.valueList = this.dataIsOperatorList;
      item.selectedValue = data?.values[0];
    } else {
      if (data?.values?.length == 1) {
        let dateRange = selectedFileld?.isDateWithTime ? this.timeZoneService._getUTCDateTimeWithZone(data?.values[0], false, true, true) : this.timeZoneService.convertToLocalDate(data?.values[0]);
        item.selectedValue = dateRange;
      } else if (data?.values?.length > 1) {
        item.selectedValue = data?.values.map((date) => {
          let dateRange = selectedFileld?.isDateWithTime ? this.timeZoneService._getUTCDateTimeWithZone(date, false, true, true) : this.timeZoneService.convertToLocalDate(date);
          return dateRange;
        });
      }
    }
  }

  forCustomValues(item: FilterObject, data: FilterInColumn) {
    if (data?.values?.length == 1) {
      item.selectedValue = item.valueList.filter(val => val == data?.values[0]);
    } else if (data?.values?.length > 1) {
      item.selectedValue = item.valueList.filter((val) => {
        return data?.values?.find((value) => {
          return value == val;
        });
      });
    }
  }

  addFilter() {
    let choice: { id: number, name: string };
    let tempFilter: FilterObject;
    if (this.filters.length > 0) {
      choice = this.filters[0].choice || this.choices[0];
    }

    tempFilter = {
      id: this.filters.length + 1,
      fields: this.listCols,
      choice: choice,
      // selectedField: this.listCols[0],
      operators: this.listCols[0].operators,
      fieldDataType: this.listCols[0].fieldDataType,
      formControlType: this.listCols[0].formControlType,
      columnName: this.listCols[0].columnName,
      isCustom: this.listCols[0].isCustom,
      hasValue: false,
      isRequired: { isFieldRequired: false, isOperatorRequired: false, isValueRequired: false, isCountryRequired: false, isStateRequired: false },
    };

    this.filters.push(tempFilter);
    // this.filterItemErrorCase(tempFilter);
  }


  removeFilter(index: number) {
    this.filters.splice(index, 1);
    this.addressValidation();
  }

  changeFilter(event, filterItem: FilterObject) {
    let countyFound: FilterObject[] = [];
    let stateFound: FilterObject[] = [];
    this.setFilterField(event, filterItem);
    if (event?.value.columnName == 'state') {
      if (this.filters.length > 0) {
        filterItem.valueList = [];
        countyFound = this.filters.filter(data => data?.columnName == 'country');
        if (countyFound.length > 0) {
          filterItem.isRequired.isCountryRequired = false;
          filterItem.isRequired.isStateRequired = false;
        } else {
          filterItem.isRequired.isCountryRequired = true;
          filterItem.isRequired.isStateRequired = false;
          filterItem.isRequired.isFieldRequired = false;
          filterItem.isRequired.isOperatorRequired = false;
        }
      }
    } else if (event?.value.columnName == 'city') {
      if (this.filters.length > 0) {
        filterItem.valueList = [];
        countyFound = this.filters.filter(data => data?.columnName == 'country');
        stateFound = this.filters.filter(data => data?.columnName == 'state');
        if (countyFound.length > 0 && stateFound.length > 0) {
          filterItem.isRequired.isStateRequired = false;
          filterItem.isRequired.isCountryRequired = false;
        } else {
          filterItem.isRequired.isStateRequired = true;
          filterItem.isRequired.isCountryRequired = false;
          filterItem.isRequired.isFieldRequired = false;
          filterItem.isRequired.isOperatorRequired = false;
        }
      }
    } else {
      filterItem.isRequired.isStateRequired = false;
      filterItem.isRequired.isCountryRequired = false;
      filterItem.isRequired.isFieldRequired = false;
      filterItem.isRequired.isOperatorRequired = false;
    }
  }

  setFilterField(event, filterItem: FilterObject) {
    if (event?.value && filterItem) {
      filterItem.selectedValue = null;
      filterItem.selectedField = event?.value;
      filterItem.operators = event?.value?.operators;
      filterItem.selectedOperator = filterItem?.operators[0];
      filterItem.formControlType = event?.value?.formControlType;
      filterItem.fieldDataType = event?.value?.fieldDataType;
      filterItem.columnName = event?.value?.columnName;
      filterItem.isCustom = event?.value?.isCustom;
      filterItem.fieldIdNo = event?.value?.id;
      filterItem.hasValue = false;
      filterItem.noValue = false;
      this.getFieldChangeValue(filterItem);
      // this.filterItemErrorCase(filterItem);
      this.addressValidation();
    }
  }

  addressValidation() {
    this.filters.forEach((data) => {
      if (data?.columnName?.toLocaleLowerCase() == 'country') {
        this.listCols = this.listColsVM.filter(cols => cols?.columnName != 'country');
      } else if (data?.columnName?.toLocaleLowerCase() == 'state') {
        this.listCols = this.listCols.filter(cols => cols?.columnName != 'state');
      } else if (data?.columnName?.toLocaleLowerCase() == 'city') {
        this.listCols = this.listCols.filter(cols => cols?.columnName != 'city');
      } else {
        this.listCols = JSON.parse(JSON.stringify(this.listColsVM));
        data.fields = this.listCols;
      }
    });
  }

  onValueChange(event, filterItem: FilterObject) {
    let selectedState: any[], selectedCountry: any[];
    if (filterItem?.columnName == 'country') {
      this.selectedCountries = event;
      this.filters.forEach((filterElement: FilterObject) => {
        if (filterElement?.columnName?.toLowerCase() == "state") {
          // selectedState = filterElement?.selectedValue;
          filterElement.valueList = [];
          this.selectedStates = [];
          filterElement.selectedValue = null;
          this.getStatesByCountry(filterElement, null, this.selectedCountries);
        } else if (filterElement?.columnName?.toLowerCase() == "city") {
          filterElement.valueList = [];
          filterElement.selectedValue = null;
          this.getCitiesByMultipleStateId(filterElement, null, null);
        }
      });
    } else if (filterItem?.columnName == 'state') {
      this.selectedStates = event;
      this.filters.forEach((filterElement: FilterObject) => {
        if (filterElement?.columnName?.toLowerCase() == "city") {
          filterElement.valueList = [];
          filterElement.selectedValue = null;
          this.getCitiesByMultipleStateId(filterElement, null, this.selectedStates);
        }
      });
    }
    this.filterItemErrorCase(filterItem);
  }

  filterItemErrorCase(filterItem: FilterObject) {
    if (filterItem?.selectedValue == null) {
      filterItem.isRequired.isValueRequired = true;
    } else if (typeof (filterItem?.selectedValue) == "string" && filterItem?.selectedValue == '') {
      if (filterItem.noValue) {
        filterItem.isRequired.isValueRequired = false;
      } else {
        filterItem.isRequired.isValueRequired = true;
      }
    } else if (typeof (filterItem?.selectedValue) == "number") {
      filterItem.isRequired.isValueRequired = false;
    } else if (filterItem?.selectedValue?.length == 0) {
      filterItem.isRequired.isValueRequired = true;
    } else {
      filterItem.isRequired.isValueRequired = false;
    }
    if (filterItem.selectedOperator == null) {
      filterItem.isRequired.isOperatorRequired = true;
    } else {
      filterItem.isRequired.isOperatorRequired = false;
    }
    if (filterItem.selectedField == null) {
      filterItem.isRequired.isFieldRequired = true;
    } else {
      filterItem.isRequired.isFieldRequired = false;
    }
  }
  // Rule Selection Code --------------------------------------------------------------------------------------------------

  onOperatorChangeRuleList(filterItem: FilterObject) {
    if (filterItem.selectedOperator == 'HasValue') {
      filterItem.selectedValue = 'Any';
    }
    else {
      filterItem.selectedValue = null;
    }
  }

  getFieldChangeValue(filterItem: FilterObject) {
    //****Custom Field */
    if (filterItem.isCustom == true) {
      if (
        filterItem.fieldDataType == 'Enum' ||
        [FormControlList.MultipleDropDownList,
        FormControlList.DropDownList,
        FormControlList.CheckBox,
        FormControlList.RadioButton,
        FormControlList.Rating
        ].includes(filterItem?.formControlType)
      ) {
        if (filterItem?.formControlType == FormControlList.Rating) {
          filterItem.valueList = this.ratingList;
        } else if (filterItem?.formControlType == FormControlList.UserLookup) {
          this.getUserList(filterItem, null);
        } else {
          filterItem.valueList = filterItem.selectedField.pickListValues;
        }
      } else if (filterItem.fieldDataType == 'Boolean' || filterItem?.formControlType == FormControlList.ToggleButton) {
        filterItem.valueList = ["true", "false"];
      }
    } else {
      filterItem.valueList = [];
      this.selectColumnField(filterItem.columnName?.toLowerCase(), filterItem, null);
    }
  }

  //#region ***API Calling***

  async selectColumnField(columnName: string, filterItem: FilterObject, data: FilterInColumn) {
    switch (columnName) {
      case 'accounttypesname':
        this.getAllAccountTypes(filterItem, data);
        break;
      case 'tags':
        this.getAllTags(filterItem, data);
        break;
      case 'title':
        this.getSalutations(filterItem, data);
        break;
      case 'timezonename':
        this.getAllTimezones(filterItem, data);
        break;
      // ------------------------
      case 'currencyname':
        this.getCurrencyList(filterItem, data);
        break;
      case 'currencyunitid':
        this.getCurrencyList(filterItem, data);
        break;
      case 'employeesrangename':
        this.getAllEmployeesCount(filterItem, data);
        break;
      case 'annualrevenuename':
        this.getAllAnnualRevenue(filterItem, data);
        break;
      case 'ownershipname':
        this.getAllOwners(filterItem, data);
        break;
      case 'owner':
      case 'assigneduser':
      case 'ownername':
        this.getUserList(filterItem, data);
        break;
      case 'visit_username':
      case 'visit_territorycontact':
      case 'createdbyusername':
      case 'response_username':
        this.getUserList(filterItem, data);
        break;
      case 'updatedbyusername':
        this.getUserList(filterItem, data);
        break;
      case 'classificationame':
        if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Account?.toLowerCase()) {
          this.getAllStages(filterItem, this.selectedParentModule.objectId, this.selectedParentModule.channelId, data);
        }
        break;
      case 'industryname':
        this.getAllIndustries(filterItem, data);
        break;
      case 'sourcename':
        if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Lead?.toLowerCase()) {
          this.getAllLeadSource(filterItem, data);
        }
        else if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Account?.toLowerCase()) {
          this.getAllAccountSource(filterItem, data);
        }
        else if (this.selectedParentModule.name.toLowerCase() == SavedSearchParentModule.Opportunity?.toLowerCase()) {
          this.getOpportunitySources(filterItem, data);
        } else if (this.selectedParentModule.objectId == CaseModuleId) {
          this.getCaseConfigData(filterItem, data);
        }
        break;
      case 'quality':
      case 'ratingname':
        this.getAllRatings(filterItem, data);
        break;
      case 'addresstypeid':
        this.getAccountAddressTypes(filterItem, data);
        break;
      case 'addressclassid':
        this.getAccountAddressClass(filterItem, data);
        break;
      case 'country':
      case 'manufacturercountry':
        this.getCountryByTemplateId(filterItem, data);
        break;
      case 'state':
        this.getStatesByCountry(filterItem, data, this.selectedCountries);
        break;
      case 'city':
        this.getCitiesByMultipleStateId(filterItem, data, this.selectedStates);
        break;
      case 'jobfunction':
        this.getJobFunction(filterItem, data);
        break;
      case 'leadtypesname':
        this.getAllLeadTypes(filterItem, data);
        break;
      case 'type':
        this.getLogTypes(filterItem, data);
        break;
      case 'logsubtype':
        this.getLogSubTypes(filterItem, data);
        break;
      case 'subtype':
        this.getLogSubTypes(filterItem, data);
        break;
      case 'stagename':
        this.getAllStages(filterItem, this.selectedParentModule.objectId, this.selectedParentModule.channelId, data);
        break;
      case 'leadsstatus':
        this.getAllLeadStatus(filterItem, data);
        break;
      case 'previousstage':
        this.getAllStages(filterItem, this.selectedParentModule.objectId, this.selectedParentModule.channelId, data);
        break;
      case 'previousstageowner':
        this.getUserList(filterItem, data);
        break;
      case 'currentstage':
        this.getAllStages(filterItem, this.selectedParentModule.objectId, this.selectedParentModule.channelId, data);
        break;
      case 'currentstageowner':
        this.getUserList(filterItem, data);
        break;
      case 'stageownername':
        this.getUserList(filterItem, data);
        break;
      case 'stagechangedby':
        this.getUserList(filterItem, data);
        break;
      case 'warehousename':
      case 'location':
        this.loadWarehouseLIst(filterItem, data);
        break;
      case 'batchname':
        this.getBatchGroup(filterItem, data);
        break;
      case 'caseassociationname':
        this.getCaseAssociationList(filterItem, data);
        break;
      case 'priorityname':
        this.getCaseConfigData(filterItem, data);
        break;
      case 'categoryname':
        this.getCasesCategories(filterItem, data);
        break;
      case 'subcategoryname':
        this.getCasesCategories(filterItem, data, false);
        break;
      case 'assignedgroup':
        this.getUserGroups(filterItem, data);
        break;
      case 'leadgrade':
        this.getLeadGrade(filterItem, data);
        break;
      case 'gender'://third parameter showing - Dynamically call the function from the sharedContactV1Service
        this.getContactModuleDropDownValue(filterItem, data, 'getAllGender');
        break;
      case 'relation':
        this.getContactModuleDropDownValue(filterItem, data, 'getAllRelationshipStatus');
        break;
      case 'marital':
        this.getContactModuleDropDownValue(filterItem, data, 'getAllMaritalStatus');
        break;
      case 'language':
        this.getContactModuleDropDownValue(filterItem, data, 'getAllLanguage');
        break;
      case 'income':
        this.getContactModuleDropDownValue(filterItem, data, 'getAllAnnualIncome');
        break;
      case 'degree':
        this.getContactModuleDropDownValue(filterItem, data, 'getAllDegree');
        break;
      case 'studyfield':
        this.getContactModuleDropDownValue(filterItem, data, 'getAllStudyField');
        break;
      case 'scoretrend':
        this.getLeadScoreTrend(filterItem, data);
        break;
      case 'assignedto':
      case 'reassignto':
      case 'createdby':
      case 'updatedby':
      case 'shareduser':
        this.getTaskUserList(filterItem, data);
        break;
      case 'priority':
        this.allTaskPriortyList(filterItem, data);
        break;
      case 'taskcategory':
        this.getTaskCategories(filterItem, data);
        break;
      case 'relatedto':
        this.getModules(filterItem, data);
        break;
      case 'status':
        this.fetchTaskStatuses(filterItem, data);
        break;
      case 'tasktype':
        this.getTaskType(filterItem, data);
        break;
      case 'contact_roles':
        this.loadContactRoles(filterItem, data);
        break;
      case 'response_visittype':
        this.getGroups('Activity Type Group', filterItem, data);
        break;
      default:
        break;
    }
  }

  //Activity
  getLogTypes(filterItem: FilterObject, data: FilterInColumn) {
    this.app.logTypesBSubject.subscribe((types) => {
      let resValue = [];
      if (types) {
        types = types?.filter(x => x?.statusId == 1);
        resValue = types.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getLogSubTypes(filterItem: FilterObject, data: FilterInColumn) {
    this.logService.getSubLogTypes(5).then((types: any) => {
      let resValue = [];
      if (types) {
        types = types?.filter(x => x?.statusId == 1);
        resValue = types.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getGroups(groupName: string, filterItem: FilterObject, data: FilterInColumn) {
    this.questionnaireDetailsService.getQustionnaireGroupIds().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response) => {
        const groupId = (response || []).find(g => g.name == groupName)?.id;
        if (groupName == 'Activity Type Group') {
          this.getVisitTypes(groupId, filterItem, data);
        }
      },
      error: (error) => {

      }
    });
  }

  getVisitTypes(visitGroupId: number, filterItem: FilterObject, data: FilterInColumn) {
    this.questionnaireDetailsService.getVisitTypes(visitGroupId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (types) => {
        let resValue = [];
        if (types) {
          types = types?.filter(x => x?.statusId == 1);
          resValue = types.map(x => ({ id: x.id, name: x.name }));
        }
        this.setDropDownValue(resValue, filterItem, data);
      },
      error: (error) => {

      }
    });
  }

  //Leads
  getAllLeadTypes(filterItem: FilterObject, data: FilterInColumn) {
    this.leadService.getAllLeadTypes(TypeGroupIds.LeadTypeLeadAPI).then(types => {
      let resValue = [];
      if (types) {
        types = types?.filter(x => x?.statusId == 1);
        resValue = types.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getAllLeadStatus(filterItem: FilterObject, data: FilterInColumn) {
    this.leadService.getAllLeadStatus(StatusGroupIds.LeadStatusGroupId).then(status => {
      let resValue = []
      if (status) {
        resValue = status.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  // Accounts

  getUserList(filterItem: FilterObject, data: FilterInColumn) {
    this.userService.getUsersWithName().then(users => {
      if (users && users.length) {
        users = users.map(u => ({ name: u.fullName, ...u }));
        let resValue = users.sort((a, b) => a.name.localeCompare(b.name));
        this.setDropDownValue(resValue, filterItem, data);
      }
    });
  }

  //Address Class
  getAccountAddressClass(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getAccountAddressClasses().subscribe(addressClasses => {
      let resValue = addressClasses;
      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getAllAccountTypes(filterItem: FilterObject, data: FilterInColumn) {
    this.ruleService.getAllAccountTypes(AccountGroupId.ID).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(types => {
      let resValue = [];
      if (types) {
        types = types || [];
        resValue = types.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    }, err => {
    });
  }

  getAllTags(filterItem: FilterObject, data: FilterInColumn) {
    this.ruleService.getAllTags().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(tags => {
      let resValue = [];
      if (tags) {
        tags = tags || [];
        resValue = tags.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    }, err => {
    });
  }

  //Salutation/Title
  getSalutations(filterItem: FilterObject, data: FilterInColumn) {
    this.contactService.getSalutations().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
      let resValue = resp || [];
      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //Timezone
  getAllTimezones(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getTimezone().then(timezoneList => {
      let resValue = []
      if (timezoneList) {
        resValue = timezoneList.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }
  //Currency
  getCurrencyList(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getCurrency().then(currencyList => {
      let resValue = []
      if (currencyList) {
        resValue = currencyList.map(x => ({ id: x.id, name: `${x.name} - ${x.code}` }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //JobFunction
  getJobFunction(filterItem: FilterObject, data: FilterInColumn) {
    this.configService.getContactRoles().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(jobFunctions => {
      let resValue = []
      if (jobFunctions) {
        resValue = jobFunctions.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //EmployeesRange
  getAllEmployeesCount(filterItem: FilterObject, data: FilterInColumn) {
    this.leadService.getAllEmployeesCount().then(count => {
      // let resValue = count.filter(el => el.statusId === 1);
      let resValue = count;
      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getAllAnnualRevenue(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getAllRevenues().then(revenue => {
      let resValue = []
      if (revenue) {
        resValue = revenue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //Owners
  getAllOwners(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getAllOwnerships().then(owners => {
      let resValue = []
      if (owners) {
        resValue = owners.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //Stage
  getAllStages(filterItem: FilterObject, objectId: number, channelId: number, data: FilterInColumn) {
    this.ruleService.getStageList(objectId, channelId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(stages => {
      let resValue = []
      if (stages) {
        // resValue = stages.filter(el => el.id && el.id !== -1).map(x => ({ id: x.id, name: x.name }));
        resValue = stages.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //Industry
  getAllIndustries(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getAllIndustries().then(industries => {
      let resValue = []
      if (industries) {
        resValue = industries.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //AccountSource
  getAllAccountSource(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getAllSources(this.app.user.organizationId).then(source => {
      let resValue = []
      if (source) {
        resValue = source.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //LeadSource
  getAllLeadSource(filterItem: FilterObject, data: FilterInColumn) {
    this.leadService.getAllSources(this.app.user.organizationId).then(source => {
      let resValue = []
      if (source) {
        resValue = source.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getOpportunitySources(filterItem: FilterObject, data: FilterInColumn) {
    this.savedSearchesService.getOpportunitySources(this.app.user.organizationId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
      let resValue = [];
      if (res) {
        resValue = res?.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    }, err => {
    });
  }

  //Rating
  getAllRatings(filterItem: FilterObject, data: FilterInColumn) {
    this.fieldService.getAllRatings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(ratings => {
      let resValue = ratings || [];
      if (ratings) {
        resValue = ratings.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //Address Type
  getAccountAddressTypes(filterItem: FilterObject, data: FilterInColumn) {
    this.accountService.getAccounAddressTypes().subscribe(addressTypes => {
      let resValue = addressTypes;
      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  //Cases Dropdown Values
  getCaseAssociationList(filterItem: FilterObject, data: FilterInColumn) {
    this.casesService.getAllContactAssociation().subscribe(response => {
      let resValue = response.filter(data => data?.name != 'Opportunity');;
      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getCasesCategories(filterItem: FilterObject, data: FilterInColumn, parent: boolean = true) {
    this.casesService.getCaseCategories().subscribe(response => {
      let resValue = response;

      if (parent) {
        resValue = resValue?.length > 0 ? resValue.filter(categoryObj => categoryObj.parentCategoryId == 0 || categoryObj.parentCategoryId == null) : [];
      } else {
        resValue = resValue?.length > 0 ? resValue.filter(categoryObj => categoryObj.parentCategoryId) : [];
      }

      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getCaseConfigData(filterItem: FilterObject, data: FilterInColumn) {
    this.casesService.getCaseConfigurations().subscribe(caseConfigs => {

      const allCasefield = JSON.parse(caseConfigs.find(s => s.name == ObjectNames.FIELD_CASES_CONFIGURATION)?.configurationDetails[0].configJSONValue);
      const sources = allCasefield.length ? allCasefield.filter(s => s.fieldsType == "Source") : [];
      const priorities = allCasefield.length ? allCasefield.filter(s => s.fieldsType == "Priority") : [];

      let resValue = [];

      if (filterItem.columnName?.toLowerCase() == 'sourcename') {
        resValue = sources.filter(data => data?.isActive);
      } else if (filterItem.columnName?.toLowerCase() == 'priorityname') {
        resValue = priorities.filter(data => data?.isActive);;
      }

      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getUserGroups(filterItem: FilterObject, data: FilterInColumn) {
    this.casesService.getUserGroups(this.app.user.organizationId).subscribe(response => {
      let resValue = response;
      if (resValue) {
        resValue = resValue.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getLeadGrade(filterItem: FilterObject, data: FilterInColumn) {
    const resValue = [
      { id: 1, name: 'A' },
      { id: 2, name: 'B' },
      { id: 3, name: 'C' },
      { id: 4, name: 'D' },
      { id: 5, name: 'E' },
    ];
    this.setDropDownValue(resValue, filterItem, data);
  }

  getContactModuleDropDownValue(filterItem: FilterObject, data: FilterInColumn, functionName: string) {
    this.sharedContactV1Service[functionName]().subscribe(resp => {
      let resValue = []
      if (resp) {
        resValue = resp?.map(x => ({ id: x.id, name: x.name }));
      }
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  getLeadScoreTrend(filterItem: FilterObject, data: FilterInColumn) {
    const resValue = [
      { id: 1, name: 'Steady' },
      { id: 2, name: 'Improving' },
      { id: 3, name: 'Declining' }
    ];
    this.setDropDownValue(resValue, filterItem, data);
  }

  getCountryByTemplateId(filterItem: FilterObject, data: FilterInColumn) {
    this.appMainService.isShowSpinner('LoadCountry');
    if (data) {
      this.selectedCountries = data?.filterValues;
    }
    this.savedSearchesService.getAllCountryDto().subscribe(res => {
      this.appMainService.isHideSpinner('LoadCountry');
      let allCountries = [];
      if (res) {
        allCountries = res.map(x => ({ id: x.id, name: x.name }));
      }
      // this.allCountryList = allCountries;
      this.setDropDownValue(allCountries, filterItem, data);
    },
      err => {
        this.appMainService.isHideSpinner('LoadCountry');
      });
  }

  getStatesByCountry(filterItem: FilterObject, data: FilterInColumn, selectedCountry?: any[]) {
    let findCountrySelected: any[];
    let countryIds: number[];
    if (data) {
      findCountrySelected = this.selectedCountries;
      this.selectedStates = data?.filterValues;
    } else {
      if (selectedCountry) {
        findCountrySelected = selectedCountry;
      }
    }
    countryIds = findCountrySelected?.map((data) => {
      return data?.id;
    });
    const Ids: string = countryIds?.join(',');
    if (findCountrySelected?.length > 0) {
      this.appMainService.isShowSpinner('loadStates');
      this.savedSearchesService.getStateByMultipleCountryIdDto(Ids).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(states => {
        this.appMainService.isHideSpinner('loadStates');
        let allStates = [];
        if (states) {
          allStates = states.map(x => ({ id: x.id, name: x.name }));
        }
        this.setDropDownValue(allStates, filterItem, data);
      },
        err => {
          this.appMainService.isHideSpinner('loadStates');
        });
    }
  }
  getCitiesByMultipleStateId(filterItem: FilterObject, data: FilterInColumn, selectedState?: any[]) {
    let findstatesSelected: any[];
    let stateIds: number[];
    if (data) {
      findstatesSelected = this.selectedStates;
    } else {
      if (selectedState?.length > 0) {
        findstatesSelected = selectedState;
      }
    }
    stateIds = findstatesSelected?.map((data) => {
      return data?.id;
    });
    const Ids: string = stateIds?.join(',');
    if (findstatesSelected?.length > 0) {
      this.appMainService.isShowSpinner('loadCities');
      this.savedSearchesService.getCitiesByMultipleStateId(Ids).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(states => {
        this.appMainService.isHideSpinner('loadCities');
        let allStates = [];
        if (states) {
          allStates = states.map(x => ({ id: x.id, name: x.name }));
        }
        this.setDropDownValue(allStates, filterItem, data);
      },
        err => {
          this.appMainService.isHideSpinner('loadCities');
        });
    }
  }

  mapToNewArrayCities(dataSet: any, id = 'id', mapField = 'name') {
    if (dataSet.length) {
      return dataSet.map(obj => ({
        id: Number(obj[id] + ""),
        name: obj[mapField],
        cities: obj.cities ? this.mapToNewArray(obj.cities) : []
      }))
    }
    return [];
  }

  mapToNewArray(dataSet: any, mapField = 'name') {
    if (dataSet.length) {
      return dataSet.map(obj => ({
        id: Number(obj.id + ""),
        name: obj[mapField],
        // count: obj?.count != null ? obj.count : null
      }))
    }
    return [];
  }

  setDropDownValue(dropDownValue: any, filterItem: FilterObject, data: FilterInColumn) {
    let selectedValueList: { name: string }[] = [];
    filterItem.valueList = dropDownValue;
    filterItem.selectedValue = null;
    if (data) {
      if (data?.filterValues.length > 0) {
        filterItem.selectedValue = data?.filterValues.map((val) => {
          let filterVal: { id: number, name: string } = {
            id: val?.id,
            name: val?.value
          }
          return filterVal;
        });
      } else {
        if (data?.values?.length == 1) {

          const selectedValue = filterItem.valueList.filter(val => val?.name == data?.values[0] || val.id == data?.values[0]);

          if (this.singleSelectFields.includes(filterItem.columnName)) {
            filterItem.selectedValue = selectedValue?.[0] || null;
          } else {
            filterItem.selectedValue = selectedValue;
          }

        } else if (data?.values?.length > 1) {
          data.values.forEach((val: string) => {
            selectedValueList.push({ name: val });
          });
          filterItem.selectedValue = filterItem.valueList.filter((val) => {
            return selectedValueList.find((item) => {
              return item?.name == val?.name || val.id == item.name;
            });
          });
        }
      }
    }
  }

  //#endregion ***API Calling End***

  changeCondition(event, index: number, filterItem: FilterObject) {
    if (index == 1) {
      filterItem.choice = event?.value;
      this.setConditionsForOthers();
    }
  }

  setConditionsForOthers() {
    let choice: { id: number, name: string } = this.filters[1].choice;
    this.filters.forEach((data: FilterObject, index: number) => {
      data.choice = choice;
    })
  }

  onSelectedOperator(event, filterItem: FilterObject) {
    if (event.value == 'HasValue') {
      filterItem.hasValue = true;
      filterItem.noValue = false;
      filterItem.selectedValue = 'any';
    } else if (event.value == 'NoValue') {
      filterItem.hasValue = false;
      filterItem.noValue = true;
      filterItem.selectedValue = '';
    } else {
      filterItem.selectedValue = '';
      filterItem.hasValue = false;
      filterItem.noValue = false;
    }

    if (['Between', 'NotBetween'].includes(event.value)) {
      filterItem.decimalBetweenNotBetweenValue = '';
    }

    filterItem.selectedValue2 = '';
    this.filterItemErrorCase(filterItem);
  }

  searchParentAccounts(event, filterItem: FilterObject) {
    if (this.isWorkspaceModule) {
      this.searchAllWorkspaces(event, filterItem);
      return;
    }
    if (filterItem.columnName.toLocaleLowerCase() == 'maincustomer') {
      this.parentAccount(filterItem);
    } else if (filterItem.columnName.toLocaleLowerCase() == 'attn') {
      this.getAllContactsNew(filterItem);
    } else if (!this.fromProductVisibilityModule && filterItem.columnName.toLocaleLowerCase() == 'itemno') {
      this.loadItemNo(event.query, filterItem);
    } else if (this.fromProductVisibilityModule && this.selectedParentModule?.name == 'Product') {
      /**Only for Product module Visibility**/
      this.loadAutoCompleteRuleOptionVisibility(event.query, filterItem, [], true);
    } else {
      /**Only for Serial,Activation & Residual details**/
      this.loadAutoCompleteOption(event.query, filterItem);
    }
  }

  searchAutocompleteItems(event: any, filterItem: FilterObject) {
    this.currentSearchFilterItem = filterItem;
    if (this.isWorkspaceModule) {
      this.searchAllWorkspaces(event, filterItem);
      return;
    }
    let channelId = this.selectedParentModule?.channelId || 0;
    let objectId = this.selectedParentModule?.objectId;

    const caseAssociationName = this.filters.find(flt => flt.columnName == 'caseAssociationName')?.selectedValue?.name;

    switch (caseAssociationName) {
      case 'Account':
        objectId = AccountModuleId;
        channelId = this.accountChannelId;
        break;
      case 'Lead':
        objectId = LeadModuleId;
        channelId = this.accountChannelId;
        break;
      case 'Organization':
        objectId = 0;
        filterItem.valueList = [{ id: this.app.user.organizationId, name: this.app.user.organizationName }];
        return;
        break;
    }

    if (objectId == LeadModuleId && ['associationname', 'businessname', 'visit_businessname'].includes(filterItem.columnName?.toLowerCase())) {
      let labelname: any = 'businessName';

      if (filterItem.columnName?.toLowerCase() == 'associationname') {
        labelname = 'nameWithSequenceNumber';
      }

      this.searchAllLeads(event, filterItem, channelId, labelname);
    } else if (objectId == AccountModuleId && ['associationname', 'maincustomer', 'businessname', 'visit_businessname'].includes(filterItem.columnName?.toLowerCase())) {
      let labelname: any = 'businessName';

      if (filterItem.columnName?.toLowerCase() == 'associationname') {
        labelname = 'nameWithSequenceNumber';
      }

      this.searchAllAccountsWithSN(event, filterItem, channelId, labelname);
    } else if (this.selectedParentModule.objectId == OpportunityModuleId && filterItem.columnName?.toLowerCase() == 'name') {
      this.searchAllOpportunities(event, filterItem, channelId);
    } else if (this.selectedParentModule.objectId == OpportunityModuleId && filterItem.columnName?.toLowerCase() == 'accountname') {
      this.searchAllAccountsWithSN(event, filterItem, channelId, 'nameWithSequenceNumber');
    } else if (this.selectedParentModule.objectId == this.salesReceiptModuleId && filterItem.columnName?.toLowerCase() == 'accountname') {
      this.searchAllAccountsWithSN(event, filterItem, channelId, 'nameWithSequenceNumber');
    } else if (this.selectedParentModule.objectId == ContactModuleId && filterItem.columnName?.toLowerCase() == 'businessname') {
      this.searchAllContactsWithSN(event, filterItem, channelId, 'businessName');
    } else if (this.selectedParentModule.objectId == this.salesReceiptModuleId && filterItem.columnName?.toLowerCase() == 'method') {
      this.searchAllPaymentMethod(event, filterItem, channelId, 'name');
    } else if (this.selectedParentModule.objectId == this.salesReceiptModuleId && filterItem.columnName?.toLowerCase() == 'number') {
      this.searchAllSalesReceipt(event, filterItem, channelId, 'number');
    } else if (this.selectedParentModule.objectId == ReconciliationReportModuleId) {
      filterItem.valueList = this.reconciliationReportSearchService.search(filterItem?.selectedField?.['field'], event.query);
    } else if (this.selectedParentModule.objectId == this.salesReceiptModuleId && filterItem.columnName?.toLowerCase() == 'status') {
      filterItem.valueList = STATUS_TYPES.filter(status => status.name.toLowerCase().includes(event.query.toLowerCase()));
    } else if (this.selectedParentModule.objectId == JournalModuleId) {
      this.getAutoSearchFiltersValue(filterItem);
    } else if (this.selectedParentModule.objectId == ReportModuleId
      || this.selectedParentModule.objectId == TrialBalanceModuleId
      || this.selectedParentModule.objectId == GeneralLedgerModuleId) {
      this.getAutoSearchFiltersValue(filterItem);
    }
    else if (this.selectedParentModule.objectId == TaskModuleId && filterItem.columnName?.toLowerCase() == 'id') {
      this.searchTaskIds(event, filterItem);
    }
    else {
      filterItem.valueList = event?.query ? [{ id: event.query, name: event.query }] : [];
    }
  }

  getAutoSearchFiltersValue(filterItem: FilterObject) {
    let filterInColumn: FilterInColumn[] = [];
    if (filterItem) {
      let item = {
        fieldId: filterItem?.fieldIdNo,
        name: filterItem?.columnName,
        displayName: filterItem?.selectedField?.name,
        operator: filterItem?.selectedOperator,
        operationType: filterItem?.choice?.name,
        values: [],
        isCustom: filterItem.isCustom,
        filterValues: [],
      };
      let itemForSaveFilterFieldsChannelWise: FilterInColumn = {
        fieldId: filterItem?.fieldIdNo,
        name: filterItem?.columnName,
        displayName: filterItem?.selectedField?.name,
        operator: filterItem?.selectedOperator,
        operationType: filterItem?.choice?.name,
        values: [],
        isCustom: filterItem.isCustom,
        filterValues: [],
      }
      this.handleValueFields(filterItem, item, itemForSaveFilterFieldsChannelWise);
      filterInColumn.push(item);
    }
    this.autoSearchFilters.emit({ filterItem: filterItem, filterInColumn: filterInColumn });
  }

  searchAllAccountsWithSN(event: any, filterItem: FilterObject, channelId: number = 0, label: 'nameWithSequenceNumber' | 'businessName' = 'nameWithSequenceNumber', querySuggest: boolean = true) {

    const requestModel: GelAllAccountRequestModel = {
      channelId: channelId,
      stageId: null,
      isActive: true,
      globalSearchValue: event.query || '',
      includeChildAccounts: true,
      selectableColumns: [
        { columnName: "sequenceNumber", isCustom: false },
        { columnName: "businessName", isCustom: false },
        { columnName: "nameWithSequenceNumber", isCUstom: false }
      ],
      filter: null,
      pageSize: 200,
      pageNumber: 1,
      sortByColumn: "",
      isSortByDescending: false,
      filterInColumns: []
    }

    this.accountServiceN.getAccountsListWithFilters(requestModel).subscribe({
      next: (response) => {
        if (response) {
          let list = response?.list ? response?.list.map(account => ({ id: account.id, name: account[label] })) || [] : [];
          const exist = list.find(obj => obj.name.toLowerCase() == event.query.toLowerCase());
          if (event.query && querySuggest && !exist) {
            list = [...[{ id: event.query, name: event.query }], ...list];
          }
          filterItem.valueList = list;
        }
      }
    })
  }

  searchAllContactsWithSN(event: any, filterItem: FilterObject, channelId: number = 0, label: 'nameWithSequenceNumber' | 'businessName' = 'nameWithSequenceNumber', querySuggest: boolean = true) {
    const requestModel: any = {
      channelId: channelId,
      stageId: null,
      isActive: true,
      globalSearchValue: event.query || '',
      associationTypeName: this.selectedParentModule?.name,
      includeChildAccounts: true,
      selectableColumns: [
        { columnName: "sequenceNumber", isCustom: false },
        { columnName: "businessName", isCustom: false },
      ],
      filter: null,
      pageSize: 200,
      pageNumber: 1,
      sortByColumn: "",
      isSortByDescending: false,
      filterInColumns: []
    }

    this.sharedContactV1Service.getContactList(requestModel).subscribe({
      next: (response) => {
        if (response) {
          let list = response?.list ? response?.list.map(account => ({ id: account.id, name: account[label] })) || [] : [];
          const exist = list?.find(obj => obj.name?.toLowerCase() == event.query?.toLowerCase());
          if (event.query && querySuggest && !exist) {
            list = [...[{ id: event.query, name: event.query }], ...list];
          }
          filterItem.valueList = list;

        }
      }
    })
  }

  searchAllLeads(event: any, filterItem: FilterObject, channelId: number = 0, label: 'nameWithSequenceNumber' | 'businessName' = 'nameWithSequenceNumber', querySuggest: boolean = true) {

    const requestModel: GetAllLeadRequestModel = {
      channelId: channelId,
      stageId: 0,
      isActive: true,
      globalSearchValue: event.query || '',
      selectableColumns: [
        { columnName: "sequenceNumber", isCustom: false },
        { columnName: "businessName", isCustom: false },
        { columnName: "nameWithSequenceNumber", isCUstom: false }
      ],
      filter: '',
      pageSize: 200,
      pageNumber: 1,
      sortByColumn: "",
      isSortByDescending: false,
      filterInColumns: []
    }

    this.leadServiceN.getLeadListWithFilters(requestModel).subscribe({
      next: (response) => {
        if (response) {
          let list = response?.list ? response?.list.map(lead => ({ id: lead.id, name: lead[label] })) || [] : [];
          const exist = list.find(obj => obj.name.toLowerCase() == event.query.toLowerCase());
          if (event.query && querySuggest && !exist) {
            list = [...[{ id: event.query, name: event.query }], ...list];
          }
          filterItem.valueList = list;
        }
      }
    })
  }
  searchAllPaymentMethod(event: any, filterItem: FilterObject, channelId: number = 0, label: 'name' | 'name' = 'name', querySuggest: boolean = true) {
    this.appMainService.isShowSpinner('loadPaymentMethod');
    this.paymentMethodService.getPaymentMrthodList()
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe({
            next: response => {
              if (response) {
                let list = response ? response?.map(method => ({ id: method.id, name: method[label] })) || [] : [];
                const exist = list.find(obj => obj.name.toLowerCase() == event.query.toLowerCase());
                if (event.query && querySuggest && !exist) {
                  list = [...[{ id: event.query, name: event.query }], ...list];
                }
                filterItem.valueList = list;
                this.appMainService.isHideSpinner('loadPaymentMethod');
              }
            },
            error: () => {
                this.appMainService.isHideSpinner('loadPaymentMethod');
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred...' });
            }
        });
  }
  searchAllSalesReceipt(event: any, filterItem: FilterObject, channelId: number = 0, label: 'number' | 'number' = 'number', querySuggest: boolean = true) {
    const requestModel = {
      channelId: channelId || 0,
      stageId: 0,
      isActive: true,
      globalSearchValue: event.query || '',
      selectableColumns: [
        { columnName: "number", isCustom: false }
      ],
      filter: '',
      pageSize: 200,
      pageNumber: 1,
      sortByColumn: "",
      isSortByDescending: false,
      filterInColumns: []
    }

    this.salesOrderService.getAllSalesReceiptsPagination(requestModel).subscribe({
      next: (response) => {
        if (response) {
          let list = response['list'] ? response['list'].map(receipt => ({ id: receipt.id, name: receipt[label] })) || [] : [];
          const exist = list.find(obj => obj.name.toLowerCase() == event.query.toLowerCase());
          if (event.query && querySuggest && !exist) {
            list = [...[{ id: event.query, name: event.query }], ...list];
          }
          filterItem.valueList = list;
        }
      }
    })
  }
  searchAllOpportunities(event: any, filterItem: FilterObject, channelId: number = 0, querySuggest: boolean = true) {

    const requestModel: GelAllOpportunityRequestModel = {
      channelId: channelId,
      accountChannelId: this.accountChannelId || 0,
      stageId: null,
      isActive: true,
      globalSearchValue: event.query || '',
      selectableColumns: [
        { columnName: "sequenceNumber", isCustom: false },
        { columnName: "name", isCustom: false },
        { columnName: "nameWithSequenceNumber", isCUstom: false }
      ],
      filter: '',
      pageSize: 200,
      pageNumber: 1,
      sortByColumn: "",
      isSortByDescending: false,
      filterInColumns: []
    }

    this.opportunitiesService.getAllOpportunities(requestModel).subscribe({
      next: (response) => {
        if (response) {
          let list = response?.list ? response?.list.map(opportunity => ({ id: opportunity.id, name: opportunity.name })) || [] : [];
          const exist = list.find(obj => obj.name.toLowerCase() == event.query.toLowerCase());
          if (event.query && querySuggest && !exist) {
            list = [...[{ id: event.query, name: event.query }], ...list];
          }
          filterItem.valueList = list;
        }
      }
    })
  }

  searchAllWorkspaces(event: any, filterItem?: FilterObject) {
    const query = event.filter || '';
    const columnId = filterItem?.selectedField?.id;
    if (filterItem?.query === undefined) {
      filterItem.query = '';
    }
    filterItem.query = query;
    this.dynamicTableService.getWorkbookColumnOptionValue(columnId, query).subscribe({
      next: (response) => {
        let list = response
        filterItem.valueList = response;
        const addedValues = filterItem?.selectedValue?.map(value => ({ id: value, value: value }));
        filterItem.valueList = [
          ...(addedValues ?? []),
          ...(list?.filter(option =>
            !(addedValues ?? []).some(selected => selected?.value == option?.value)
          ) ?? []),
        ];
      },
      error: (error) => {
        filterItem.valueList = [];
      }
    })
  }

  parentAccount(filterItem: FilterObject) {
    this.accountsHttpService.getAccountList(filterItem.selectedValue).subscribe({
      next: (response) => {
        filterItem.valueList = response;
      },
      error: (error) => {

      }
    })
  }

  getAllContactsNew(filterItem: FilterObject) {
    const requestModel: GelAllContactRequestModel = {
      associationTypeName: "",
      isActive: true,
      globalSearchValue: filterItem.selectedValue,
      selectableColumns: [{ columnName: 'fullName' }],
      filter: 'allcontacts',
      pageSize: 15,
      pageNumber: 1,
      sortByColumn: null,
      isSortByDescending: true,
      filterableColumns: [],
      globalChannelId: 1,
    }

    this.contactService.getContactList(requestModel)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          if (response?.list?.length > 0) {
            filterItem.valueList = response?.list?.map((x) => {
              return { id: x.id, name: x.fullName };
            });
          }
        },
        error: (error) => {
          this.noContactFindOrLoadingText = 'No Contacts found.';
          this.messageService.add({
            severity: 'error',
            summary: 'Error!',
            detail: 'Error occurring when loading Contacts. Please try after sometime.'
          });
          this.appMainService.isHideSpinner('getAllContactLoader');
        },
        complete: () => {

        }
      })
  }


  searchTaskIds(event: any, filterItem: FilterObject, querySuggest: boolean = true) {

    const requestModel: any = {
      searchKey: event.query || '',
      filterType: this.selectedFilterValue ?? '',
    }

    this.taskService.getTaskIds(requestModel).subscribe({
      next: (response) => {
        if (response) {
          let list = response ? response.map(task => ({ id: task.taskId, name: task.taskId })) || [] : [];
          const exist = list.find(obj => obj.name.toLowerCase() == event.query.toLowerCase());
          if (event.query && querySuggest && !exist) {
            list = [...[{ id: event.query, name: event.query }], ...list];
          }
          filterItem.valueList = list;
        }
      }
    })
  }

  applyFilters() {
    this.selectedColumns = [];
    let selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[] = [];
    this.filters.forEach((tempFilter) => {
      this.filterItemErrorCase(tempFilter);
    });
    this.empltyFields = this.filters.filter((data) => {
      return data?.isRequired?.isFieldRequired == true || data?.isRequired?.isOperatorRequired == true || data?.isRequired?.isValueRequired == true || data?.isRequired?.isCountryRequired == true || data?.isRequired?.isStateRequired == true;
    });
    if (this.empltyFields.length == 0 && this.filters?.length > 0) {
      this.filters.forEach((data: FilterObject, index: number) => {
        let item: FilterInColumn = {
          fieldId: data?.fieldIdNo,
          name: data?.columnName,
          displayName: data?.selectedField?.name,
          operator: data?.selectedOperator,
          operationType: data?.choice?.name,
          values: [],
          isCustom: data.isCustom,
          filterValues: [],
        }
        let itemForSaveFilterFieldsChannelWise: FilterInColumn = {
          fieldId: data?.fieldIdNo,
          name: data?.columnName,
          displayName: data?.selectedField?.name,
          operator: data?.selectedOperator,
          operationType: data?.choice?.name,
          values: [],
          isCustom: data.isCustom,
          filterValues: [],
        }
        this.handleValueFields(data, item, itemForSaveFilterFieldsChannelWise);
        this.selectedColumns.push(item);
        selectedColumnsForSaveFilterFieldsChannelWise.push(itemForSaveFilterFieldsChannelWise);
      });
      //this.appliedSlectedColumns = JSON.parse(JSON.stringify(this.filters));
      this.appliedSlectedColumns = [...this.filters];
      this.applyFiltersColumns.emit({ selectedFilter: this.selectedColumns, selectedColumnsForSaveFilterFieldsChannelWise: selectedColumnsForSaveFilterFieldsChannelWise });
      this.isSelectedChannelWise = false;
      this.filterOptions.hide();
    }
  }


  public dateOnOperatorListValue(filterItem: FilterObject, item: FilterInColumn, itemForSaveFilterFieldsChannelWise?: FilterInColumn) {

    const today = new Date();
    const todayCopy = new Date(today);
    const startMonth = 0; // January
    const startDate = 1;
    const endMonth = 11; // December
    const endDate = 31;

    const startOfFiscalYear = new Date(today.getFullYear(), startMonth, startDate);
    const endOfFiscalYear = new Date(today.getFullYear(), endMonth, endDate);

    let dateRangeFrom: Date | null = null;
    let dateRangeTo: Date | null = null;
    item.values = [];

    const getStartOfWeek = (date: Date) => {
      const copy = new Date(date);
      const day = copy.getDay();
      const diff = copy.getDate() - day; // Sunday as the first day
      return new Date(copy.setDate(diff));
    };

    const getEndOfWeek = (date: Date) => {
      const startOfWeek = getStartOfWeek(date);
      return new Date(startOfWeek.getFullYear(), startOfWeek.getMonth(), startOfWeek.getDate() + 6);
    };

    const getQuarter = (date: Date) => Math.floor(date.getMonth() / 3);
    const getQuarterStartEnd = (year: number, quarter: number) => {
      const start = new Date(year, quarter * 3, 1);
      const end = new Date(year, quarter * 3 + 3, 0);
      return { start, end };
    };

    switch (filterItem.selectedValue) {
      case 'Today':
        dateRangeFrom = today;
        dateRangeTo = today;
        break;
      case 'Yesterday':
        const yest = new Date(todayCopy);
        yest.setDate(yest.getDate() - 1);
        dateRangeFrom = yest;
        dateRangeTo = yest;
        break;
      case 'Tomorrow':
        const tmr = new Date(todayCopy);
        tmr.setDate(tmr.getDate() + 1);
        dateRangeFrom = tmr;
        dateRangeTo = tmr;
        break;
      case 'Last 7 Days':
        dateRangeFrom = new Date(todayCopy.setDate(todayCopy.getDate() - 7));
        dateRangeTo = today;
        break;
      case 'Last 15 Days':
        dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 15));
        dateRangeTo = today;
        break;
      case 'Last 30 Days':
        dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 30));
        dateRangeTo = today;
        break;
      case 'Last 60 Days':
        dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 60));
        dateRangeTo = today;
        break;
      case 'Last 90 Days':
        dateRangeFrom = new Date(todayCopy.setDate(today.getDate() - 90));
        dateRangeTo = today;
        break;
      case 'Last Week':
        const lastWeekEnd = getStartOfWeek(today);
        const lastWeekStart = new Date(lastWeekEnd);
        lastWeekStart.setDate(lastWeekStart.getDate() - 7);
        dateRangeFrom = lastWeekStart;
        dateRangeTo = new Date(lastWeekEnd.setDate(lastWeekEnd.getDate() - 1));
        break;
      case 'Last Week-to-date': {
        const weekStartsOnMonday = false; // set false if your week starts on Sunday
        const currentDay = today.getDay(); // 0 (Sun) to 6 (Sat)

        // Calculate offset for start of current week
        const offset = weekStartsOnMonday ? (currentDay === 0 ? -6 : 1 - currentDay) : -currentDay;

        // Start of current week
        const startOfCurrentWeek = new Date(today);
        startOfCurrentWeek.setDate(today.getDate() + offset);

        // Start of last week
        const startOfLastWeek = new Date(startOfCurrentWeek);
        startOfLastWeek.setDate(startOfCurrentWeek.getDate() - 7);

        // Get same weekday as today in last week
        const sameWeekdayAsTodayLastWeek = new Date(startOfLastWeek);
        sameWeekdayAsTodayLastWeek.setDate(startOfLastWeek.getDate() + (weekStartsOnMonday ? (currentDay === 0 ? 6 : currentDay - 1) : currentDay));

        dateRangeFrom = startOfLastWeek;
        dateRangeTo = sameWeekdayAsTodayLastWeek;
        break;
      }
      case 'This Week':
        dateRangeFrom = getStartOfWeek(today);
        dateRangeTo = getEndOfWeek(today);
        break;
      case 'This Week-to-date':
        dateRangeFrom = getStartOfWeek(today);
        dateRangeTo = today;
        break;
      case 'Next Week':
        const nextWeekStart = getEndOfWeek(today);
        nextWeekStart.setDate(nextWeekStart.getDate() + 1);
        const nextWeekEnd = new Date(nextWeekStart);
        nextWeekEnd.setDate(nextWeekStart.getDate() + 6);
        dateRangeFrom = nextWeekStart;
        dateRangeTo = nextWeekEnd;
        break;
      case 'Next Week-to-date': {
        const startOfNextWeek = getStartOfWeek(today);
        startOfNextWeek.setDate(startOfNextWeek.getDate() + 7); // Start of next week
        dateRangeFrom = startOfNextWeek;

        const endOfNextWeek = new Date(startOfNextWeek);
        endOfNextWeek.setDate(endOfNextWeek.getDate() + (today.getDay())); // Same day in next week
        dateRangeTo = endOfNextWeek;
        break;
      }
      case 'Last Month':
        dateRangeFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        dateRangeTo = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'Last Month-to-date': {
        const year = today.getFullYear();
        const currentMonth = today.getMonth(); // 0-based
        const lastMonth = currentMonth - 1;

        const startOfLastMonth = new Date(year, lastMonth, 1);

        const lastDayOfLastMonth = new Date(year, currentMonth, 0).getDate();
        const day = Math.min(today.getDate(), lastDayOfLastMonth);
        const toDateLastMonth = new Date(year, lastMonth, day);

        dateRangeFrom = startOfLastMonth;
        dateRangeTo = toDateLastMonth;
        break;
      }
      case 'This Month':
        dateRangeFrom = new Date(today.getFullYear(), today.getMonth(), 1);
        dateRangeTo = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 'This Month-to-date':
        dateRangeFrom = new Date(today.getFullYear(), today.getMonth(), 1);
        dateRangeTo = today;
        break;
      case 'Next Month':
        dateRangeFrom = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        dateRangeTo = new Date(today.getFullYear(), today.getMonth() + 2, 0);
        break;
      case 'Next Month-to-date':
        const year = today.getFullYear();
        const month = today.getMonth();
        const startOfNextMonth = new Date(year, month + 1, 1);

        const dayOfMonth = today.getDate();
        const lastDayOfNextMonth = new Date(year, month + 2, 0).getDate();
        const toDateDay = Math.min(dayOfMonth, lastDayOfNextMonth);

        const sameDayNextMonth = new Date(year, month + 1, toDateDay);

        dateRangeFrom = startOfNextMonth;
        dateRangeTo = sameDayNextMonth;
        break;
      case 'Last Fiscal Quarter': {
        const quarter = getQuarter(today) - 1 < 0 ? 3 : getQuarter(today) - 1;
        const year = quarter === 3 ? today.getFullYear() - 1 : today.getFullYear();
        const { start, end } = getQuarterStartEnd(year, quarter);
        dateRangeFrom = start;
        dateRangeTo = end;
        break;
      }
      case 'Last Fiscal Quarter-to-date': {
        let currentQuarter = getQuarter(today); // 1 to 4
        let lastQuarter = currentQuarter - 1;
        let year = today.getFullYear();

        if (lastQuarter === 0) {
          lastQuarter = 4;
          year -= 1;
        }

        const { start: startOfLastQuarter } = getQuarterStartEnd(year, lastQuarter);

        const { start: startOfCurrentQuarter } = getQuarterStartEnd(today.getFullYear(), currentQuarter);
        const dayOffset = Math.floor((today.getTime() - startOfCurrentQuarter.getTime()) / (1000 * 60 * 60 * 24));

        const toDateInLastQuarter = new Date(startOfLastQuarter);
        toDateInLastQuarter.setDate(toDateInLastQuarter.getDate() + dayOffset);

        const { end: endOfLastQuarter } = getQuarterStartEnd(year, lastQuarter);
        if (toDateInLastQuarter > endOfLastQuarter) {
          toDateInLastQuarter.setTime(endOfLastQuarter.getTime());
        }

        dateRangeFrom = startOfLastQuarter;
        dateRangeTo = toDateInLastQuarter;
        break;
      }
      case 'This Fiscal Quarter': {
        const quarter = getQuarter(today);
        const { start, end } = getQuarterStartEnd(today.getFullYear(), quarter);
        dateRangeFrom = start;
        dateRangeTo = end;
        break;
      }
      case 'This Fiscal Quarter-to-date': {
        const quarter = getQuarter(today);
        const { start } = getQuarterStartEnd(today.getFullYear(), quarter);
        dateRangeFrom = start;
        dateRangeTo = today;
        break;
      }
      case 'Next Fiscal Quarter': {
        const quarter = getQuarter(today) + 1 > 3 ? 0 : getQuarter(today) + 1;
        const year = quarter === 0 ? today.getFullYear() + 1 : today.getFullYear();
        const { start, end } = getQuarterStartEnd(year, quarter);
        dateRangeFrom = start;
        dateRangeTo = end;
        break;
      }
      case 'Next Fiscal Quarter-to-date': {
        const currentQuarter = getQuarter(today); // 1-based: 1 to 4
        let nextQuarter = currentQuarter + 1;
        let year = today.getFullYear();

        if (nextQuarter > 4) {
          nextQuarter = 1;
          year += 1;
        }

        const { start: startOfNextQuarter, end: endOfNextQuarter } = getQuarterStartEnd(year, nextQuarter);
        const { start: startOfCurrentQuarter } = getQuarterStartEnd(today.getFullYear(), currentQuarter);

        const dayOffset = Math.floor((today.getTime() - startOfCurrentQuarter.getTime()) / (1000 * 60 * 60 * 24));

        const toDateInNextQuarter = new Date(startOfNextQuarter);
        toDateInNextQuarter.setDate(toDateInNextQuarter.getDate() + dayOffset);

        if (toDateInNextQuarter > endOfNextQuarter) {
          toDateInNextQuarter.setTime(endOfNextQuarter.getTime());
        }

        dateRangeFrom = startOfNextQuarter;
        dateRangeTo = toDateInNextQuarter;
        break;
      }
      case 'Last Fiscal Year':
        dateRangeFrom = new Date(today.getFullYear() - 1, startMonth, startDate);
        dateRangeTo = new Date(today.getFullYear() - 1, endMonth, endDate);
        break;
      case 'Last Fiscal Year-to-date': {
        const lastYear = today.getFullYear() - 1;

        // Start of last fiscal year (Jan 1)
        const startOfLastFiscalYear = new Date(lastYear, 0, 1);

        // "To date" in last fiscal year, same month/day as today
        let toDateLastFiscalYear = new Date(lastYear, today.getMonth(), today.getDate());

        // Clamp to end of last fiscal year in case today’s date (e.g., Feb 29) doesn’t exist in last year
        const endOfLastFiscalYear = new Date(lastYear, 11, 31);
        if (toDateLastFiscalYear > endOfLastFiscalYear) {
          toDateLastFiscalYear = endOfLastFiscalYear;
        }

        dateRangeFrom = startOfLastFiscalYear;
        dateRangeTo = toDateLastFiscalYear;
        break;
      }
      case 'This Fiscal Year':
        dateRangeFrom = startOfFiscalYear;
        dateRangeTo = endOfFiscalYear;
        break;
      case 'This Fiscal Year-to-Last Month':
        dateRangeFrom = startOfFiscalYear;
        dateRangeTo = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'This Fiscal Year-to-date':
        dateRangeFrom = startOfFiscalYear;
        dateRangeTo = today;
        break;
      case 'Next Fiscal Year':
        dateRangeFrom = new Date(today.getFullYear() + 1, startMonth, startDate);
        dateRangeTo = new Date(today.getFullYear() + 1, endMonth, endDate);
        break;
      case 'Next Fiscal Year-to-date': {
        const nextYear = today.getFullYear() + 1;
        const startOfNextFiscalYear = new Date(nextYear, 0, 1);
        let endOfToDate = new Date(nextYear, today.getMonth(), today.getDate());
        const endOfNextFiscalYear = new Date(nextYear, 11, 31);
        if (endOfToDate > endOfNextFiscalYear) {
          endOfToDate = endOfNextFiscalYear;
        }

        dateRangeFrom = startOfNextFiscalYear;
        dateRangeTo = endOfToDate;
        break;
      }
      default:
        dateRangeFrom = null;
        dateRangeTo = null;
        break;
    }
    // const { dateRangeFrom: newDateRangeFrom, dateRangeTo: newDateRangeTo } = filterDateRangeHelper(filterItem.selectedValue);
    // dateRangeFrom = newDateRangeFrom;
    // dateRangeTo = newDateRangeTo;

    if ((dateRangeFrom && dateRangeTo)) {
      item.operator = filterItem.selectedOperator == 'NotOn' ? 'NotBetween' : 'Between';
      dateRangeFrom = this.timeZoneService._getUTCDateTimeWithZone(dateRangeFrom, (filterItem?.selectedField?.isDateWithTime || false), true, !['This Month', 'Last Month'].includes(filterItem.selectedValue));
      dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateRangeTo, (filterItem?.selectedField?.isDateWithTime || false), true, !['This Month', 'Last Month'].includes(filterItem.selectedValue));
      dateRangeTo.setDate(dateRangeTo.getDate() + 1);
      dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
      item.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeFrom), this.timeZoneService._getUTCDateTimeString(dateRangeTo));
    }

    itemForSaveFilterFieldsChannelWise.operator = filterItem?.selectedOperator;
    itemForSaveFilterFieldsChannelWise.values.push(filterItem?.selectedValue);

    if (filterItem?.formControlType == 'Time') {

      item.values.push(filterItem?.selectedValue);
      if (filterItem?.selectedValue2) {
        item.values.push(filterItem?.selectedValue2);
        itemForSaveFilterFieldsChannelWise.values.push(filterItem?.selectedValue2);
      }

      if (['On', 'NotOn'].includes(filterItem.selectedOperator)) {
        item.operator = filterItem.selectedOperator == 'NotOn' ? 'NotBetween' : 'Between';
        item.values.push(filterItem.selectedValue)
      }
    }
  }

  setValueForSingleDate(filterItem: FilterObject, item: FilterInColumn, itemForSaveFilterFieldsChannelWise: FilterInColumn) {
    // "On", "NotOn", "Before", "OnOrBefore", "After", "OnOrAfter", "Between", "HasValue", "NoValue"
    item.values = [];
    itemForSaveFilterFieldsChannelWise.values = [];
    const dateValue: Date = new Date(filterItem.selectedValue);
    if (['OnOrBefore', 'After'].includes(filterItem.selectedOperator)) {
      let dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateValue, (filterItem?.selectedField?.isDateWithTime || false), true, false);
      dateRangeTo.setDate(dateRangeTo.getDate() + 1);
      dateRangeTo = new Date(dateRangeTo.getTime() - 1000);
      item.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeTo));
      itemForSaveFilterFieldsChannelWise.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeTo));
    } else {
      let dateRangeTo = this.timeZoneService._getUTCDateTimeWithZone(dateValue, (filterItem?.selectedField?.isDateWithTime || false), true, false);
      item.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeTo));
      itemForSaveFilterFieldsChannelWise.values.push(this.timeZoneService._getUTCDateTimeString(dateRangeTo));
    }

  }

  handleValueFields(data: FilterObject, item: FilterInColumn, itemForSaveFilterFieldsChannelWise: FilterInColumn) {
    if (typeof (data.selectedValue) == 'string' || typeof (data.selectedValue) == 'number' || (data.fieldDataType == 'String' && data.formControlType == 'DatePicker' && typeof (data.selectedValue) == 'object')) {
      if (['Time', 'DateTime'].includes(data.fieldDataType) && !(data.hasValue || data.noValue)) {
        this.dateOnOperatorListValue(data, item, itemForSaveFilterFieldsChannelWise);
      } else {
        item.values.push(data?.selectedValue);
        itemForSaveFilterFieldsChannelWise.values.push(data?.selectedValue);
        if (data.selectedOperator == 'Between' || data.selectedOperator == 'NotBetween') {
          item.values.push(data.decimalBetweenNotBetweenValue);
          itemForSaveFilterFieldsChannelWise.values.push(data.decimalBetweenNotBetweenValue);
        }
      }
    } else {
      if (data?.selectedValue?.length > 0) {
        item.values = [];
        itemForSaveFilterFieldsChannelWise.values = [];
        data.selectedValue.map((selectedItem, index) => {
          if (data?.fieldDataType == 'Enum') {
            // selectedItem?.name ? item.values.push(selectedItem?.name) : item.values.push(selectedItem);
            let valueSelection: string = data?.selectedField?.valueSelection || 'name';
            if (this.isTaskModule || (data?.formControlType == "UserLookup" && this.isWorkspaceModule)) {
              valueSelection = 'id';
            }

            if (selectedItem[valueSelection]) {
              item.values.push(selectedItem[valueSelection]);
              itemForSaveFilterFieldsChannelWise.values.push(selectedItem[valueSelection]);
              if (data?.columnName == 'country' || data?.columnName == 'state' || data?.columnName == 'city') {
                let addressData: { id: number, value: string } = {
                  id: selectedItem?.id,
                  value: selectedItem?.name,
                }
                itemForSaveFilterFieldsChannelWise.filterValues.push(addressData);
                item.filterValues.push(addressData);
              }
            } else if (data?.columnName.toLowerCase() == 'assetaccount' || data?.columnName.toLowerCase() == 'cogsaccount'
              || data?.columnName.toLowerCase() == 'glimpactaccount' || data?.columnName.toLowerCase() == 'incomeaccount'
              || data?.columnName.toLowerCase() == 'class' || data?.columnName.toLowerCase() == 'category'
              || data?.columnName.toLowerCase() == 'uom' || data?.columnName.toLowerCase() == 'expenseaccount') {
              item.values.push(selectedItem.label);
              itemForSaveFilterFieldsChannelWise.values.push(selectedItem.label);
            } else {
              item.values.push(selectedItem);
              itemForSaveFilterFieldsChannelWise.values.push(selectedItem);
            }
          } else if (data?.selectedField?.fieldDataType == 'DateTime') {
            let singleDateRangeHandle = selectedItem != null ? selectedItem : data.selectedValue[0];
            if (data.selectedOperator == 'Between' && selectedItem == null) {
              data.selectedValue[1] = singleDateRangeHandle;
            }
            let rawDate = this.timeZoneService._getUTCDateTimeWithZone(singleDateRangeHandle, (data?.selectedField?.isDateWithTime || false), true, false);
            if (index > 0) {
              rawDate.setDate(rawDate.getDate() + 1);
              rawDate = new Date(rawDate.getTime() - 1000);
            }
            item.values.push(this.timeZoneService._getUTCDateTimeString(rawDate));
            itemForSaveFilterFieldsChannelWise.values.push(this.timeZoneService._getUTCDateTimeString(rawDate));
          } else {
            item.values.push(selectedItem);
            itemForSaveFilterFieldsChannelWise.values.push(selectedItem);
          }
        });
      } else {
        if (data?.fieldDataType == 'Enum') {
          // data?.selectedValue?.name ? item.values.push(data?.selectedValue?.name) : item.values.push(data?.selectedValue);
          if (data?.selectedValue?.name) {
            item.values.push(data?.selectedValue?.name)
            itemForSaveFilterFieldsChannelWise.values.push(data?.selectedValue?.name)
          } else {
            item.values.push(data?.selectedValue);
            itemForSaveFilterFieldsChannelWise.values.push(data?.selectedValue);
          }
        } else if (data?.selectedField?.fieldDataType == 'DateTime') {
          this.setValueForSingleDate(data, item, itemForSaveFilterFieldsChannelWise);
        } else {
          if (this.isTaskModule) {
            item.values.push(data?.selectedValue?.id);
            itemForSaveFilterFieldsChannelWise.values.push(data?.selectedValue?.id);
          } else {
            item.values.push(data?.selectedValue?.name);
            itemForSaveFilterFieldsChannelWise.values.push(data?.selectedValue?.name);

            if (this.autoCompleteFieldsForBetweenNotBetween.includes(data?.columnName) && (data?.selectedOperator == 'Between' || data?.selectedOperator == 'NotBetween')) {
              item.values.push(data?.selectedValue2?.name);
              itemForSaveFilterFieldsChannelWise.values.push(data?.selectedValue2?.name);
            }
          }
        }
      }
    }
  }

  filterErrorHandling() {
    this.filters.forEach((data: FilterObject) => {
      if (data?.selectedValue == null) {
        data.isRequired.isValueRequired = true;
      } else if (data?.selectedValue == "") {
        if (data.noValue) {
          data.isRequired.isValueRequired = false;
        } else {
          data.isRequired.isValueRequired = false;
        }
      } else {
        data.isRequired.isValueRequired = false;
      }
      if (data.selectedOperator == null) {
        data.isRequired.isOperatorRequired = true;
      } else {
        data.isRequired.isOperatorRequired = false;
      }
      if (data.selectedField == null) {
        data.isRequired.isFieldRequired = true;
      } else {
        data.isRequired.isFieldRequired = false;
      }
    });
  }

  resetFilter() {
    this.filters = [];
    this.appliedSlectedColumns = [];
    this.isSelectedChannelWise = false;
    this.listCols = JSON.parse(JSON.stringify(this.listColsVM));
    this.filters.push({
      id: 1,
      choice: this.choices[0],
      fields: this.listCols,
      operators: null,
      selectedOperator: null,
      formControlType: 'InputBox',
      fieldDataType: 'String',
      hasValue: false,
      isRequired: { isFieldRequired: false, isOperatorRequired: false, isValueRequired: false, isCountryRequired: false, isStateRequired: false },
    });
    this.applyFiltersColumns.emit({ selectedFilter: null, selectedColumnsForSaveFilterFieldsChannelWise: null });
  }

  resetToAppliedFilters() {
    if (this.appliedSlectedColumns?.length > 0 && (this.selectedColumns?.length > 0 || this.isSelectedChannelWise)) {
      //this.filters = JSON.parse(JSON.stringify(this.appliedSlectedColumns));
      this.filters = [...this.appliedSlectedColumns];
      this.dateTimeEditSelection();
      this.addressValidation();
    } else {
      this.clearFilterOnChannelChange();
    }
  }

  clearFilterOnChannelChange() {
    this.appliedSlectedColumns = JSON.parse(JSON.stringify([]));
    this.filters = JSON.parse(JSON.stringify([]));
    this.selectedColumns = [];
    let tempFilter: FilterObject;
    this.listCols = this.listColsVM ? JSON.parse(JSON.stringify(this.listColsVM)) : [];
    tempFilter = {
      id: 0,
      choice: this.choices[0],
      fields: this.listCols,
      operators: null,
      selectedOperator: null,
      formControlType: 'InputBox',
      fieldDataType: 'String',
      hasValue: false,
      isRequired: { isFieldRequired: false, isOperatorRequired: false, isValueRequired: false, isCountryRequired: false, isStateRequired: false },
    }
    this.filters.push(tempFilter);
    // this.filterItemErrorCase(tempFilter);
  }

  dateTimeEditSelection() {
    this.filters.forEach((filterObject: FilterObject) => {
      if (filterObject.formControlType == 'Time') {
        filterObject.selectedValue = filterObject.selectedValue;
      } else if (filterObject.fieldDataType == 'DateTime') {
        if (typeof (filterObject.selectedValue) == 'string') {
          filterObject.selectedValue = filterObject.selectedOperator == 'On' || filterObject.selectedOperator == 'NotOn' || filterObject.selectedOperator == 'HasValue' || filterObject.selectedOperator == 'NoValue' ? filterObject.selectedValue : new Date(filterObject.selectedValue);
        } else {
          if (filterObject?.selectedValue?.length > 0) {
            filterObject.selectedValue = filterObject.selectedValue.map((date) => {
              // let localDate = this.timeZoneService.convertToLocalDate(date);
              date = new Date(date);
              return date;
            })
          } else {
            filterObject.selectedValue = new Date(filterObject.selectedValue);
          }
        }
      }
    });
  }

  /**Filters for Serial/Residual/Activation Details**/
  loadItemNo(searchValue: string, filterItem: FilterObject) {
    this.importService.getItemNoBySearch(searchValue).subscribe({
      next: (response) => {
        // Sorting based on the 'name' property alphabetically
        response.sort((a, b) => a.name.localeCompare(b.name));
        filterItem.valueList = response;
      },
      error: (error) => {
        filterItem.valueList = [];
      }
    })
  }

  loadAutoCompleteOption(searchValue: string, filterItem: FilterObject) {
    this.importService.getAutoCompleteByFieldName(searchValue, filterItem).subscribe({
      next: (response) => {
        // Sorting based on the 'name' property alphabetically
        response.sort((a, b) => a.name.localeCompare(b.name));
        filterItem.valueList = response;
      },
      error: (error) => {
        filterItem.valueList = [];
      }
    })
  }

  loadAutoCompleteRuleOptionVisibility(searchValue: string, filterItem: FilterObject, data, autoComplete: boolean) {
    this.importService.getAutoCompleteRuleByFieldName(searchValue, filterItem).subscribe({
      next: (response) => {
        if (autoComplete) {
          // Sorting based on the 'name' property alphabetically
          response.sort((a, b) => a.name.localeCompare(b.name));
          filterItem.valueList = response;
        } else {
          let resValue = response.sort((a, b) => a.name.localeCompare(b.name));
          this.setDropDownValue(resValue, filterItem, data);
        }
      },
      error: (error) => {
        filterItem.valueList = [];
      }
    })
  }

  loadAllFinancialAccounts(type, filterItem, savedParam) {
    this.importService.getAllFinancialAccounts().subscribe(accounts => {
      let data = []
      for (let c of accounts) {
        let ChildData = [];
        for (let s of c.childAccounts) {
          let subData = [];
          for (let subb of s.childAccounts) {
            let childSubbData = [];
            for (let subChild of subb.childAccounts) {
              if (subChild.statusId == 1) {
                let eachSubChild: any = {
                  label: subChild.name,
                  value: subChild,
                  children: [],
                };
                childSubbData.push(eachSubChild);
              }
            }
            if (subb.statusId == 1) {
              let eachSub = {
                label: subb.name,
                value: subb,
                children: childSubbData,
              };
              subData.push(eachSub);
            }
          }
          if (s.statusId == 1) {
            let eachSub = {
              label: s.name,
              value: s,
              children: subData
            }
            ChildData.push(eachSub)
          }
        }
        if (c.statusId == 1) {
          let eachData = {
            label: c.name,
            value: c,
            children: ChildData
          }
          data.push(eachData)
        }
      }
      const financialAccounts = data;
      if (type != 'Chart of Accounts') {
        filterItem.treeSelectData = financialAccounts?.filter(
          (acc) => acc.label == type
        );
      } else {
        filterItem.treeSelectData = financialAccounts;
      }
      if (savedParam?.values) {
        this.getSavedFinancialAccount(filterItem, filterItem.treeSelectData, savedParam.values)
      }
    })
  }

  getSavedFinancialAccount(filterItem, list, savedParam) {
    const filteredCategories = [];
    savedParam.forEach((element) => {
      const cat = list.filter(
        (cat) => cat.label == element
      )[0];
      if (cat) {
        filteredCategories.push(cat);
      }
    });
    savedParam.forEach((element) => {
      list.forEach((cat) => {
        const childCat = cat.children.filter(
          (child) => child.label == element
        )[0];
        if (childCat) {
          filteredCategories.push(childCat);
        }
      });
    });
    savedParam.forEach((element) => {
      list.forEach((cat) => {
        cat.children.forEach((childCat) => {
          const subChildCat = childCat.children.filter(
            (child) => child.label == element
          )[0];
          if (subChildCat) {
            filteredCategories.push(subChildCat);
          }
        });
      });
    });
    savedParam.forEach((element) => {
      list.forEach((cat) => {
        cat.children.forEach((childCat) => {
          childCat.children.forEach((childSub) => {
            const childSubChildCat = childSub.children.filter(
              (child) => child.label == element
            )[0];
            if (childSubChildCat) {
              filteredCategories.push(childSubChildCat);
            }
          });
        });
      });
    });
    filterItem.selectedValue = filteredCategories
  }

  getAllClass(filterItem, savedParam) {
    this.productsService.getClasses().subscribe((cls) => {
      let data = []
      for (let c of cls) {
        let ChildData = [];
        for (let s of c.childClass) {
          let subData = [];
          for (let subb of s.childClass) {
            let childSubbData = [];
            if (subb.statusId == 1) {
              let eachSub = {
                label: subb.name,
                value: subb,
                children: childSubbData,
              };
              subData.push(eachSub);
            }
          }
          if (s.statusId == 1) {
            let eachSub = {
              label: s.name,
              value: s,
              children: subData
            }
            ChildData.push(eachSub)
          }
        }
        if (c.statusId == 1) {
          let eachData = {
            label: c.name,
            value: c,
            children: ChildData
          }
          data.push(eachData)
        }
      }
      filterItem.treeSelectData = data;
      if (savedParam?.values) {
        this.getSavedFinancialAccount(filterItem, filterItem.treeSelectData, savedParam.values)
      }
    });
  }

  getUnitOfMeasures(filterItem, savedParam) {
    this.productsService.getAllMeasurements().subscribe((units) => {
      let data = []
      for (let c of units) {
        let ChildData = [];
        for (let s of c.childUOM) {
          let subData = [];
          for (let subb of s.childUOM) {
            let childSubbData = [];
            if (subb.statusId == 1) {
              let eachSub = {
                label: subb.name,
                value: subb,
                children: childSubbData,
              };
              subData.push(eachSub);
            }
          }
          if (s.statusId == 1) {
            let eachSub = {
              label: s.name,
              value: s,
              children: subData
            }
            ChildData.push(eachSub)
          }
        }
        if (c.statusId == 1) {
          let eachData = {
            label: c.name,
            value: c,
            children: ChildData
          }
          data.push(eachData)
        }
      }
      filterItem.treeSelectData = data;
      if (savedParam?.values) {
        this.getSavedFinancialAccount(filterItem, filterItem.treeSelectData, savedParam.values);
      }
    });
  }

  getInventoryGroup(filterItem, data) {
    this.savedSearchesService.getInventoryGroups().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(res => {
      if (res?.length) {
        const inventoryGroups = res;
        const categoryGroup = inventoryGroups?.filter(grp => grp.name == 'Product Category')[0];
        this.getProductCategory(categoryGroup?.id, filterItem, data)
      }
    }, err => {
    });
  }

  getProductCategory(productcatId, filterItem, data) {
    this.productsService
      .getAllProductCategoryList(productcatId)
      .subscribe((cat) => {
        // Category Tree
        let cateData = [];
        for (let children of cat) {
          let childrenData = [];
          for (let sub of children.childCategory) {
            let subData = [];
            for (let subb of sub.childCategory) {
              let childSubbData = [];
              for (let childsubb of subb.childCategory) {
                if (childsubb.statusId == 1) {
                  let eachSubb = {
                    label: childsubb.name,
                    value: childsubb,
                    children: [],
                  };
                  childSubbData.push(eachSubb);
                }
              }
              if (subb.statusId == 1) {
                let eachSub = {
                  label: subb.name,
                  value: subb,
                  children: childSubbData,
                };
                subData.push(eachSub);
              }
            }

            if (sub.statusId == 1) {
              let eachChildItem = {
                label: sub.name,
                value: sub,
                children: subData,
              };
              childrenData.push(eachChildItem);
            }
          }

          if (children.statusId == 1) {
            let eachItem = {
              label: children.name,
              value: children,
              children: childrenData,
            };
            cateData.push(eachItem);
          }
        }
        filterItem.treeSelectData = cateData;
        if (data?.values) {
          this.getSavedFinancialAccount(filterItem, filterItem.treeSelectData, data.values);
        }
      });
  }

  loadWarehouseLIst(filterItem, data) {
    this.importService.getAllLocations(true).subscribe((wHouse) => {
      let resValue = wHouse.sort((a, b) => a.customName.localeCompare(b.customName));
      this.setDropDownValue(resValue, filterItem, data);
    });
  }

  /**batches**/
  getBatchGroup(filterItem, data) {
    this.importService.getAllGroups().subscribe((groups) => {
      const batchGroup = groups.find(group => group.name == 'Serial Batches');
      this.getSerialBatches(batchGroup.id, filterItem, data);
    })
  }

  getSerialBatches(groupId, filterItem, data) {
    this.importService.getAllGroupTypes(groupId).subscribe((batch) => {
      let resValue = batch.sort((a, b) => a.name.localeCompare(b.name));
      this.setDropDownValue(resValue, filterItem, data);
    })
  }


  getTaskUserList(filterItem: FilterObject, data: FilterInColumn) {
    const resValue = this.app.usersList.filter(obj => obj.statusId == 1);
    this.setDropDownValue(resValue, filterItem, data);
  }

  allTaskPriortyList(filterItem: FilterObject, data: FilterInColumn) {
    this.appMainService.isShowSpinner('setNotification&EmailValues');
    this.taskService.allTaskPriorityList().subscribe({
      next: (response) => {
        const resValue = response;
        this.setDropDownValue(resValue, filterItem, data);
        this.appMainService.isHideSpinner('setNotification&EmailValues');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('setNotification&EmailValues');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.Message ?? 'Something went wrong'
        });
      }
    })

  }
  getTaskCategories(filterItem: FilterObject, data: FilterInColumn): void {
    this.taskService.getTaskActiveCategoryGet().subscribe({
      next: (response: any) => {
        const resValue = response;
        this.setDropDownValue(resValue, filterItem, data);

      }
    })
  }

  getModules(filterItem: FilterObject, data: FilterInColumn): void {
    this.taskService.getTaskModules().subscribe({
      next: (response) => {
        const resValue = response ?? [];
        this.setDropDownValue(resValue, filterItem, data);
      },
      error: (error) => {
      }
    })
  }

  fetchTaskStatuses(filterItem: FilterObject, data: FilterInColumn) {
    this.appMainService.isShowSpinner("fetchTaskStatuses");
    this.taskService
      .getTaskStatuses()
      .then((taskStatuses: TaskStatus[]) => {
        this.appMainService.isHideSpinner("fetchTaskStatuses");
        const resValue = taskStatuses;
        this.setDropDownValue(resValue, filterItem, data);
      }).catch(() => {
        this.appMainService.isHideSpinner("fetchTaskStatuses");
      });
  }

  getTaskType(filterItem: FilterObject, data: FilterInColumn): void {
    this.taskService.getTaskType().subscribe({
      next: (response) => {
        const resValue = response ?? [];
        this.setDropDownValue(resValue, filterItem, data);
      },
      error: (error) => {
      }
    })
  }

  loadContactRoles(filterItem: FilterObject, data: FilterInColumn): void {
    this.configService.getNewAllContactRoles().subscribe({
      next: (resp: any[]) => {
        const resValue = resp?.length ? resp : [];
        this.setDropDownValue(resValue, filterItem, data);
      },
      error: (err) => {
      }
    });
  }

}
